/* eslint-disable react/display-name, react/prop-types */
import * as React from 'react';

import './Player.css';

interface PlayerProps extends React.HTMLProps<HTMLVideoElement> {
  video?: string;
  ready?: string;
}

export default React.memo(
  React.forwardRef<HTMLVideoElement, PlayerProps>((props, ref) =>
    props.video ? (
      <video className={'video-player'} controls ref={ref} {...props}>
        {props.children}
      </video>
    ) : (
      <audio className={'audio-player'} controls controlsList={'nodownload'} ref={ref} {...props} />
    ),
  ),
);
